import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {environment} from '~environments/environment';
import {ExportRequest} from '../models';

/**
 * Service for exporting data.
 */
@Injectable()
export class ExportService {
  public API_URL: any = `${environment.envAPI}`;

  public i18nClickHereToDownload: string = $localize`:@@general.notification.clickHereToDownload:Click here to download`;
  public i18nExportInitiated: string = $localize`:@@general.notification.exportInitated:Export successfully initiated. The requested file will be available shortly. You can now leave this page.`;
  public i18nExportReady: string = $localize`:@@general.notification.exportReady:Requested export file is now available and is ready to be downloaded.`;

  constructor(private http: HttpClient,) {
  }

  /**
   * Create export request
   */
  public createExportRequest(exportRequest: any): Observable<ExportRequest> {
    return this.http.post<ExportRequest>(`${this.API_URL}/export-requests`, exportRequest);
  }

  /**
   * Get export request by id
   */
  public getExportRequestById(exportRequestId: number): Observable<ExportRequest> {
    return this.http.get<ExportRequest>(`${this.API_URL}/export-requests/${exportRequestId}`);
  }
}
